import { Fragment, type ReactNode } from "react"

import styles from "./messages.module.scss"

interface Props {
  text: string
  itemId?: string
  // Maps {{filter_code}} tokens in `text` to the short ingredient name to show
  // as a pill. Absent for plain typed messages, which render as text.
  ingredients?: Record<string, string>
}

const TOKEN = /{{([^{}]+)}}/g

// Swap each known {{filter_code}} token for a pill showing the short name;
// unknown tokens and surrounding text render as-is.
const renderContent = (text: string, ingredients: Record<string, string>): ReactNode => {
  const nodes: ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null
  TOKEN.lastIndex = 0
  while ((match = TOKEN.exec(text)) !== null) {
    const name = ingredients[match[1]]
    if (name === undefined) continue
    if (match.index > lastIndex) nodes.push(<Fragment key={lastIndex}>{text.slice(lastIndex, match.index)}</Fragment>)
    nodes.push(
      <span key={match.index} className={styles["ingredient-pill"]}>
        {name}
      </span>
    )
    lastIndex = match.index + match[0].length
  }
  if (lastIndex < text.length) nodes.push(<Fragment key={lastIndex}>{text.slice(lastIndex)}</Fragment>)
  return nodes
}

const UserBubble = ({ text, itemId, ingredients }: Props) => (
  <div className={`${styles["row"]} ${styles["row--user"]}`} data-item-id={itemId} data-testid="user-bubble">
    <span className={styles["user-bubble"]}>{ingredients ? renderContent(text, ingredients) : text}</span>
  </div>
)

export default UserBubble
